import { render } from "./WeightedScoresPage.vue?vue&type=template&id=33e31588&ts=true"
import script from "./WeightedScoresPage.vue?vue&type=script&lang=ts"
export * from "./WeightedScoresPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__